import { render, staticRenderFns } from "./OrganizationHorizontalMenu.vue?vue&type=template&id=cd8af3be&scoped=true"
import script from "./OrganizationHorizontalMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./OrganizationHorizontalMenu.vue?vue&type=script&setup=true&lang=js"
import style0 from "./OrganizationHorizontalMenu.vue?vue&type=style&index=0&id=cd8af3be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd8af3be",
  null
  
)

export default component.exports